
import { Query } from '@datorama/akita';
import { TimeAndAttendanceState } from './time-and-attendance.model';
import { timeAndAttendanceStore, TimeAndAttendanceStore } from './time-and-attendance.store';

export class TimeAndAttendanceQuery extends Query<TimeAndAttendanceState> {
  constructor(protected store: TimeAndAttendanceStore) {
    super(store);
  }
}

export const timeAndAttendanceQuery = new TimeAndAttendanceQuery(timeAndAttendanceStore);